import { Check, Loader2, Sparkles, X } from "lucide-react";

export default function AnalyzingPhase({ photos }) {
  const doneCount = photos.filter((p) => p.status === "done").length;
  return (
    <div className="py-12 space-y-4">
      <div className="flex flex-col items-center gap-3">
        <div className="relative">
          <Loader2 size={42} className="animate-spin text-[#2E4A3B]" />
          <Sparkles size={16} className="absolute inset-0 m-auto text-[#C65D47]" />
        </div>
        <div className="text-center">
          <div className="font-semibold text-sm">Analisi in corso...</div>
          <div className="text-xs text-[#8E918C] mt-1">
            {doneCount} di {photos.length} foto completate
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {photos.map((p, i) => (
          <div
            key={p.id}
            data-testid={`receipt-progress-${i}`}
            className={`relative aspect-square rounded-lg overflow-hidden border ${
              p.status === "done"
                ? "border-[#2E4A3B]"
                : p.status === "error"
                ? "border-[#C65D47]"
                : "border-[#EAE7E1]"
            }`}
          >
            <img src={p.preview} alt={`Foto ${i + 1}`} className="w-full h-full object-cover" />
            <div
              className={`absolute inset-0 flex items-center justify-center ${
                p.status === "analyzing"
                  ? "bg-black/40"
                  : p.status === "done"
                  ? "bg-[#2E4A3B]/30"
                  : p.status === "error"
                  ? "bg-[#C65D47]/30"
                  : ""
              }`}
            >
              {p.status === "analyzing" && <Loader2 size={20} className="animate-spin text-white" />}
              {p.status === "done" && <Check size={22} className="text-white" />}
              {p.status === "error" && <X size={22} className="text-white" />}
            </div>
            <div className="absolute bottom-0 inset-x-0 bg-black/60 text-white text-[10px] font-mono px-1.5 py-0.5 text-center">
              Foto {i + 1}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
